import React from "react";

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import { withApollo } from "react-apollo";
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from "moment";
import 'moment/locale/es';
import Reflux from "reflux";
import { UserStore } from "../../store/UserStore";

import { GET_COMERCIAL_DETAIL } from "../../queries/comercial/detail";
import { GET_USER_DATA } from "../../queries/users/users.queries";
import { ResponsivePie } from '@nivo/pie'
import { ResponsiveBar } from '@nivo/bar'

import numberWithPoints from "../../utils/numberWithPoints";
import { ThunderboltFilled, FireFilled } from '@ant-design/icons';
import listaSubmin from "../../assets/img/icons/custom/lista_submin.svg";
import listaSubminGas from "../../assets/img/icons/custom/lista_submin_gas.svg";
import listaEmpresas from "../../assets/img/icons/custom/lista_empresas.svg";
import listadoPS from "../../assets/img/icons/custom/listadoPS.svg";
import propuestaMulti from "../../assets/img/icons/custom/propuestaMulti.svg";
import gestionPropuestas from "../../assets/img/icons/custom/gestion_propuestas.svg";
import gestionContratos from "../../assets/img/icons/custom/gestion_contratos.svg";
//import {PieChart, Pie, Sector, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

// JavaScript library that creates a callendar with events
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from '@fullcalendar/list';
import uuid from "react-uuid";
import esLocale from "@fullcalendar/core/locales/es";
//import "@fullcalendar/timegrid/main.css";

const colors = scaleOrdinal(schemeCategory10).range();

class Header extends Reflux.Component<any, any> {
    state = {
        UserStore: {},
        companyIdUser: '',
        userName: '',
        companyNameUser: '',
        userGroupId: 1000,
        userId: '',
        idCard: "",
        first_name1: "",
        last_name1: "",
        showIndexButton: false,
        showFreeMarketButton: false,
        isLoading2: false,
        dataResumenContratos: {
            totalAceptados: 0,
            totalContratos: 0,
            totalEnEspera: 0,
            ultimaFecha: ''
        },
        dataResumenContratosChart0: [{
            name: "",
            contratos: 0
        }],
        dataResumenContratosChart1: [{
            name: "",
            value: 0
        }],
        dataResumenContratosFirmados: {
            totalFirmaContrato: 0,
            totalContratos: 0,
            totalEnEspera: 0,
            totalContratosGeneradoEnviado: 0,
            totalFechaContrato: 0,
            totalFechaActivacion: 0
        },
        dataResumenContratosFirmadosChart: [{
            name: "Contrato Totales",
            totalFirmaContrato: 0,
            totalContratos: 0,
            totalEnEspera: 0,
            totalContratosGeneradoEnviado: 0,
            totalFechaContrato: 0,
            totalFechaActivacion: 0
        }],
        dataChart1: [{
            Aceptados: 0,
            Anno: 0,
            Baja: 0,
            Contratos: 0,
            Denegados: 0,
            EnEspera: 0,
            Mes: 1,
            Renovacion: 0
        }],
        dataContractTrin: [{
            fecha: "2023-01", aceptados: 0, enEspera: 0,
            renovacion: 0, denegados: 0, baja: 0, contratos: 0
        }],
        isLoading: false,
        data: {
            supplier_id: 0,
            num_sites: 0,
            kwhanual: 0,
            supplier_name: "",
            supplier_code_ree: "",
            persona_fisica_total_sites: 0,
            persona_fisica_sumkwhanual: 0,
            persona_juridica_total_sites: 0,
            persona_juridica_sumkwhanual: 0,
        },
        events: [
            {
                title: "",
                start: "",
                end: "",
                className: "",
                id: "",
                description: "",
                allDay: true,
                extendedProps: {
                    idComercial: null,
                    comercial: "",
                    tipoDocumento: "",
                    tipoEnergia: "",
                    idCliente: "",
                    nombreCliente: "",
                    propuestaIdEvento: "",
                    propuestaNombreEvento: "",
                    propuestaFechaInicioEvento: "",
                    estado: "",
                    idEstado: "",
                },
            },
        ],
    };


    constructor(props) {
        super(props);
        this.store = UserStore;
    };

    componentDidMount() {
        this.getUserData();
        this.fetchItems();
    };

    async getUserData() {

        const resp = await this.props.client.query({
            query: GET_USER_DATA,
        });

        const user = resp.data.userData;

        this.setState({

            first_name1: user.first_name,
            last_name1: user.last_name,
        });
        this.QueryResumenContratosAlt(user.email, user.companyId, user.id, user.user_group_id);
        this.QueryResumenContratosFirmadosAlt(user.email, user.companyId, user.id, user.user_group_id);
        this.QueryResumenChart(user.email, user.companyId, user.id, user.user_group_id);
        this.getcalendarioList(user.companyId, user.id, );
    };

    async getcalendarioList(companyId, id ) {

        var iduserProceso = id;
        var idEmpresaProceso = companyId;


        let eventoDesde = "";
        let eventoHasta = "";


        let now = new Date()
        let start = new Date(now);

        start.setMonth(start.getMonth() - 3);
        eventoDesde = start.toISOString();

        let end = new Date(now);
        end.setMonth(end.getMonth() + 5);
        eventoHasta = end.toISOString();

        var dataFilters = {
            start: eventoDesde,
            end: eventoHasta,
            idComercial: iduserProceso,
            idEstado: ""
        };

        const valores = JSON.stringify(dataFilters);

        const headers = {
            Authorization: "Bearer my-token",
            "My-Custom-Header": "foobar",
            "Content-Type": "application/json",
            "x-api-key":
                "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
        };

        let direccionFile =
            "https://datapi.psgestion.es/eventos/lista?id=" + idEmpresaProceso + "&user=" + iduserProceso;

        await axios
            .get(direccionFile, { headers, params: { valores } })
            .then((result) => {
                //console.log('resultado', result)
                var events = result.data.rows;

                this.setState({
                    events: events,
                });
                //return this.state.events
            })
            .catch((error) => {
                this.setState({
                    isLoading: false,
                });
            });
    }


    UNSAFE_componentWillReceiveProps() {


        const usuario: any = JSON.parse(JSON.stringify(this.state.UserStore['data']))

        const companyNameGlobal = usuario.company;
        const companyIdUser = usuario.companyId;

        const userGroupId = usuario.user_group_id
        const userId = usuario.id
        const userName = usuario.first_name + " " + usuario.last_name
        const idCard = usuario.email

        let showIndexButton = usuario.indexada;
        let showFreeMarketButton = usuario.mercadolibre;
        let companyNameUser = usuario.company;

        if (userGroupId === 1000) {
            this.setState({
                activeUser: true
            })
        };

        this.setState({
            companyNameGlobal,
            companyIdUser,
            userGroupId,
            userId,
            showIndexButton,
            userName,
            showFreeMarketButton,
            companyNameUser,
            idCard

        });
    }


    UNSAFE_componentWillMount() {


        var userFromStorageTemp = localStorage.getItem("user");
        var parsedTemp = JSON.parse(userFromStorageTemp || '{}');
        var userIdTemp = parsedTemp.id;
        var companyIdUserTemp = parsedTemp.companyId;
        var userGroupId = parsedTemp.user_group_id;
        var company = parsedTemp.company;
        var idCard = parsedTemp.email;

        this.setState({

            companyIdUser: companyIdUserTemp,
            userId: userIdTemp,
            userGroupId: userGroupId,
            companyNameUser: company,
            idCard: idCard

        });

    };

    ///////////////////////////////////////////////////////////////////////////////////////////

    fetchItems = async () => {
        let isLoading = true;
        this.setState({ isLoading });

        const sips = await this.props.client.query({
            query: GET_COMERCIAL_DETAIL,
        });
        const data = sips.data.getComercialDetail;

        isLoading = false;
        this.setState({ data, isLoading });
    };



    //////////////////////////////////////////////////////////////////////////////////////

    QueryResumenContratosAlt = async (idcard1, companyIdUser1, userId1, userGroupId1) => {

        let isLoading = true;
        const isSearching = true;
        const companyId = companyIdUser1.toString()
        const userId = '-1'


        var userIdAux = userId1.toString();
        var userQuery = userId1.toString();
        var idCard = idcard1;

        if (userGroupId1 === 1000) {
            userIdAux = "1000"
        } else {
            userIdAux = userId1.toString();
        }

        const headers = {
            'Authorization': 'Bearer my-token',
            'My-Custom-Header': 'foobar',
            'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
        };
        let direccionFile = "https://datapi.psgestion.es/propuesta/resumen?id=" + companyId + "&user=" + userIdAux;

        await axios.get(direccionFile, { headers }).
            then(result => {

                const data = result.data.rows[0]
                let dataAux = result.data.rows[0]

                let newDataChart: any = data;

                const keys = Object.keys(data);
                const res: any[] = [];
                res.push({
                    'name': keys[1],
                    'contratos': data[keys[1]]
                });

                //delete newDataChart['totalContratos'];
                //delete newDataChart['ultimaFecha'];

                const keys1 = Object.keys(newDataChart);
                const res1: any = [];
                for (let i = 0; i < keys1.length; i++) {
                    if (i == 1 || i == 3) { } else {

                        let label = "Total aceptados"
                        if (keys1[i] === "totalEnEspera") {
                            label = "Total en espera"
                        }

                        res1.push({
                            'id': keys1[i],
                            'label': label,
                            'value': newDataChart[keys1[i]]
                        });
                    }
                };

                this.setState({
                    dataResumenContratos: data,
                    //dataResumenContratosChart: result2
                    dataResumenContratosChart0: res,
                    dataResumenContratosChart1: res1,
                    isLoading2: false
                });
            }).catch((error) => {
                console.log('Failure ', error)
            });

    };



    ////////////////////////////////////////////////////////////////////////////////////////////


    QueryResumenContratosFirmadosAlt = async (idcard1, companyIdUser1, userId1, userGroupId1) => {

        let isLoading = true;
        const isSearching = true;
        const companyId = companyIdUser1.toString()
        const userId = '-1'

        var userIdAux = userId1.toString();
        var userQuery = userId1.toString();
        var idCard = idcard1;

        if (userGroupId1 === 1000) {

            userIdAux = "1000"
        } else {
            userIdAux = userId1.toString();
        }

        const headers = {
            'Authorization': 'Bearer my-token',
            'My-Custom-Header': 'foobar',
            'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
        };
        let direccionFile = "https://datapi.psgestion.es/contrato/resumen?id=" + companyId + "&user=" + userIdAux + "&idcard=" + idCard;

        await axios.get(direccionFile, { headers }).
            then((result: any) => {

                let data = result.data.rows[0]

                console.log('Tipo de data: ', typeof (data), ' data: ', data)

                let newDataChart: any = data;

                let result2 = Object
                    .keys(newDataChart)
                    .map(k => ({ "name": k, "contratos": newDataChart[k] }));


                let newDataChartAux: any[] = []


                newDataChart['name'] = "Contratos Totales";


                newDataChartAux.push(newDataChart)


                /*
                            console.log('Tipo de data: ', typeof(data), ' data: ', data)
                
                            let dataContractTrin:any[] = [];
                
                            data.map((row) => {
                              console.log(row)
                            //for(var i=0;i<=dataaceptados.length;i++){
                              let name = row['anio']+"-"+row['label'];
                              let estado = "Aceptados";
                              let valor = parseInt(row['data']);
                              //console.log('VALOR DE FECHA ACEPTADO ----> ', fechaAceptado)
                
                              dataContractTrin.push({ fecha: fecha, estado: estado, valor: valor});
                
                            //}
                          })
                */




                this.setState({
                    dataResumenContratosFirmados: data,
                    dataResumenContratosFirmadosChart: result2
                });
            }).catch((error) => {
                console.log('Failure ', error)
            });

    };

    ///////////////////////////////////////////////////////////////////////////////////////////
    QueryResumenChart = async (idcard1, companyIdUser1, userId1, userGroupId1) => {

        let isLoading = true;
        const isSearching = true;
        const companyId = companyIdUser1.toString()
        const userId = '-1'


        var userIdAux = userId1.toString();
        var userQuery = userId1.toString();
        var idCard = idcard1;

        if (userGroupId1 === 1000) {
            userIdAux = "1000"
        } else {
            userIdAux = userId1.toString();
        }

        var userTime = "S"

        const headers = {
            'Authorization': 'Bearer my-token',
            'My-Custom-Header': 'foobar',
            'x-api-key': '$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W'
        };
        let direccionFile = "https://datapi.psgestion.es/cuadro/chartAceptados?id=" + companyId + "&user=" + userIdAux + "&time=" + userTime + "";


        await axios.get(direccionFile, { headers }).
            then(result => {

                const data = result.data.rows

                if (data.length > 0) {

                    console.log('Tipo de data: ', typeof (data), ' data: ', data)

                    let dataContractTrin: any[] = [];

                    data.map((row) => {
                        let fecha = row['Anno'] + "-" + row['Mes'];
                        let aceptados = row['Aceptados'];
                        let enEspera = row['EnEspera'];
                        let renovacion = row['Renovacion'];
                        let denegados = row['Denegados'];
                        let baja = row['Baja'];
                        let contratos = row['Contratos'];

                        dataContractTrin.push({
                            fecha: fecha, aceptados: aceptados, enEspera: enEspera,
                            renovacion: renovacion, denegados: denegados, baja: baja, contratos: contratos
                        });
                    })

                    this.setState({
                        dataChart1: data,
                        dataContractTrin: dataContractTrin
                    });
                }
            }).catch((error) => {
                console.log('Failure ', error)
            });
    };

    /////////////////////////////////////////////////////////////////////////////////

    render() {

        var datosPropuestas = this.state.dataResumenContratosChart1

        console.log('valor de this.state en Render: ', this.state)
        const styleFullWith = { "width": "100%" };

        var fechaUltimaPropuestaFormateo = ''

        if (!this.state.dataResumenContratos.ultimaFecha) {
            fechaUltimaPropuestaFormateo = "SIN DATOS"

        } else {
            fechaUltimaPropuestaFormateo = moment(this.state.dataResumenContratos.ultimaFecha).format("DD-MM-YYYY")
        }

        return (
            <>
                <div className="header  pb-8 pt-5 pt-lg-5">

                    <Container fluid>
                        <div className="header-body pb-4 pt-1 ">
                            <Row>

                                <h2 className="font-weight-bold mb-0">BIENVENIDO! {this.state.first_name1} </h2 >
                            </Row>
                        </div>
                    </Container>


                    <Container fluid className="mb-4">

                        <div className="header-body">
                            <Row>

                                <Col className="px-1 py-1" sm="4" md={true}>
                                    <Link to="/admin/sips" id="sips">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-3 p-1 align-self-end badge rounded-circle bg-yellow " />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center ">
                                                        <h3><img src={listaSubmin} /></h3>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Listado suministros eléctricos
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>

                                <Col className="px-1 py-1" sm="4" md={true}>
                                    <Link to="/admin/gassips" id="sipsGas">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <FireFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-3 p-1 align-self-end badge rounded-circle bg-blue " />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center ">
                                                        <h3><img src={listaSubminGas} /></h3>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Listado suministros gas
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>


                                <Col className="px-1 py-1" sm="4" md={true} >
                                    <Link to={{ pathname: "empresa/" }} id="empresa">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <FireFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-0 align-self-end badge rounded-circle bg-blue p-1" />
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto mr-3 align-self-end badge rounded-circle bg-yellow p-1" />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center ">
                                                        <h1><img src={listaEmpresas} /></h1>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Listado empresas
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>

                                <Col className="px-1 py-1" sm="4" md={true} >
                                    <Link to={{ pathname: "reports/" }} id="sips-listado-global">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <FireFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-0 align-self-end badge rounded-circle bg-blue p-1" />
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto mr-3 align-self-end badge rounded-circle bg-yellow p-1" />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center ">
                                                        <h1><img src={listadoPS} /></h1>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Listado PS global
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>

                                <Col className="px-1 py-1" sm="4" md={true} >
                                    <Link to={{ pathname: "multips/" }} id="multips">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-3 align-self-end badge rounded-circle bg-yellow p-1" />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center ">
                                                        <h1><img src={propuestaMulti} /></h1>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Propuesta multipunto
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>

                                <Col className="px-1 py-1" sm="4" md={true} >
                                    <Link to={{ pathname: "GestionPropuesta/" }} id="gestio-propuesta">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-3 align-self-end badge rounded-circle bg-yellow p-1" />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center">
                                                        <h1><img src={gestionPropuestas} /></h1>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Gestión propuestas
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>

                                <Col className="px-1 py-1" sm="4" md={true} >
                                    <Link to={{ pathname: "GestionContratos" }} id="gestio-contrato">
                                        <Card className="card-stats mb-4 mb-xl-0 h-100 btn p-1">
                                            <CardBody className="p-0">
                                                <Row>
                                                    <ThunderboltFilled style={{ fontSize: '14px', color: '#ffffff' }} className="col-auto ml-auto mr-3 align-self-end badge rounded-circle bg-yellow p-1" />
                                                </Row>
                                                <Row>
                                                    <Col className="col col-8 m-auto text-center">
                                                        <h1><img src={gestionContratos} /></h1>
                                                    </Col>
                                                </Row>
                                                <Row className="m-auto">
                                                    <div className="col">
                                                        <CardTitle
                                                            className="text-center mb-0"
                                                        >
                                                            Gestión contratos
                                                        </CardTitle>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Link>
                                </Col>


                            </Row>


                        </div>
                    </Container>

                    <Container fluid>

<Row className="card-deck" style={styleFullWith}>
    <Col md="3" lg="3" >
        <Card className="card-stats">
            <CardBody>
                <Row>
                    <div className="col">
                        <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                        >
                            TOTAL PROPUESTAS
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                            {this.state.dataResumenContratos.totalContratos || 0}
                        </span>
                    </div>
                    <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                            <i className="bi bi-files" />
                        </div>
                    </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                    <span className="text-nowrap">Propuesta totales realizadas</span>
                </p>
            </CardBody>
        </Card>

        <Card className="card-stats">
            <CardBody>
                <Row>
                    <div className="col">
                        <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                        >
                            FECHA ULT. PROPUESTA
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                            {fechaUltimaPropuestaFormateo}
                        </span>
                    </div>
                    <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                            <i className="bi bi-calendar-event" />
                        </div>
                    </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                    {" "}
                    <span className="text-nowrap">Fecha última propuesta</span>
                </p>
            </CardBody>
        </Card>
    </Col>

    <Col Col md="3" lg="3">
        <Card className="card-stats">
            <CardBody>
                <Row>
                    <div className="col">
                        <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                        >
                            ACEPTADOS
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                            {this.state.dataResumenContratosFirmados.totalFechaContrato || 0}
                        </span>
                    </div>
                    <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                            <i className="bi bi-check2-circle" />
                        </div>
                    </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                    {" "}
                    <span className="text-nowrap">Contratos aceptados últimos 3 meses</span>
                </p>
            </CardBody>
        </Card>

        <Card className="card-stats">
            <CardBody>
                <Row>
                    <div className="col">
                        <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                        >
                            FIRMADOS
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                            {this.state.dataResumenContratosFirmados.totalFirmaContrato || 0}
                        </span>
                    </div>
                    <Col className="col-auto">
                        <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                            <i className="bi bi-file-medical" />
                        </div>
                    </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                    {" "}
                    <span className="text-nowrap">Contratos firmados últimos 3 meses</span>
                </p>
            </CardBody>
        </Card>
    </Col>
    <Col Col md="6" lg="6" >
        <Card className="card-calendar">
            <FullCalendar
                initialView={"listWeek"}
                views={{
                    listDay: { buttonText: 'Día' },
                    listWeek: { buttonText: 'Semana' },
                    listMonth: { buttonText: 'Mes' }
                }}
                headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "listDay,listWeek,listMonth",
                }}
                themeSystem={"bootstrap"}
                plugins={[listPlugin]}
                selectable={true}
                editable={true}
                locale={esLocale}
                events={this.state.events}
                //eventClick={this.handleEventClick}
                //select={this.handleSelect}
                displayEventEnd={true}
                //eventDrop={this.handleSelectDrop}
                showNonCurrentDates={false}
            //events= {this.state.events}
            //events={() => this.dataFecha()}
            />
        </Card>



    </Col>
</Row>

</Container>

                    <Container fluid>
                        <div className="header-body pb-2 pt-1 ">
                            <Row>
                                <h2 className="font-weight-bold mb-0">DATOS RESUMEN PROPUESTAS </h2 >
                            </Row>
                        </div>
                    </Container>
                    <Container fluid>

                        <Row className="card-deck" style={styleFullWith}>
                            <Col md="6" xl="6">
                                <Card className="card-stats" style={{ height: 450 }}>

                                    <ResponsivePie
                                        data={this.state.dataResumenContratosChart1}
                                        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={3}
                                        activeOuterRadiusOffset={8}
                                        borderWidth={1}
                                        borderColor={{
                                            from: 'color',
                                            modifiers: [
                                                [
                                                    'darker',
                                                    0.2
                                                ]
                                            ]
                                        }}
                                        enableArcLinkLabels={false}
                                        arcLinkLabelsSkipAngle={10}
                                        arcLinkLabelsTextColor="#333333"
                                        arcLinkLabelsThickness={2}
                                        arcLinkLabelsColor={{ from: 'color' }}
                                        arcLabelsSkipAngle={10}
                                        arcLabelsTextColor={{
                                            from: 'color',
                                            modifiers: [
                                                [
                                                    'darker',
                                                    2
                                                ]
                                            ]
                                        }}
                                        defs={[
                                            {
                                                id: 'dots',
                                                type: 'patternDots',
                                                background: 'inherit',
                                                color: 'rgba(255, 255, 255, 0.3)',
                                                size: 4,
                                                padding: 1,
                                                stagger: true
                                            },
                                            {
                                                id: 'lines',
                                                type: 'patternLines',
                                                background: 'inherit',
                                                color: 'rgba(255, 255, 255, 0.3)',
                                                rotation: -45,
                                                lineWidth: 6,
                                                spacing: 10
                                            }
                                        ]}
                                        fill={[
                                            {
                                                match: {
                                                    id: 'totalAceptados'
                                                },
                                                id: 'dots'
                                            },
                                            {
                                                match: {
                                                    id: 'totalEnEspera'
                                                },
                                                id: 'dots'
                                            }
                                        ]}
                                        valueFormat={value =>
                                            `${Number(value).toLocaleString('es-ES', {
                                                minimumFractionDigits: 0,
                                            })}`
                                        }
                                        legends={[
                                            {
                                                anchor: 'bottom',
                                                direction: 'row',
                                                justify: false,
                                                translateX: 0,
                                                translateY: 56,
                                                itemsSpacing: 10,
                                                itemWidth: 100,
                                                itemHeight: 18,
                                                itemTextColor: '#999',
                                                itemDirection: 'left-to-right',
                                                itemOpacity: 1,
                                                symbolSize: 18,
                                                symbolShape: 'circle',
                                                effects: [
                                                    {
                                                        on: 'hover',
                                                        style: {
                                                            itemTextColor: '#000'
                                                        }
                                                    }
                                                ]
                                            }
                                        ]}
                                    />

                                </Card>
                            </Col>

                            <Col md="6" xl="6">
                                <Card className="card-stats" style={{ height: 450 }}>
                                    <ResponsiveBar
                                        data={this.state.dataContractTrin}
                                        keys={[
                                            'aceptados',
                                            'enEspera',
                                            'renovacion',
                                            'denegados',
                                            'baja',
                                            'contratos'

                                        ]}
                                        indexBy="fecha"
                                        groupMode="grouped"
                                        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                                        padding={0.3}
                                        valueScale={{ type: 'linear' }}
                                        indexScale={{ type: 'band', round: true }}
                                        colors={{ scheme: 'nivo' }}
                                        borderColor={{
                                            from: 'color',
                                            modifiers: [
                                                [
                                                    'darker',
                                                    1.6
                                                ]
                                            ]
                                        }}
                                        axisTop={null}
                                        axisRight={null}
                                        axisBottom={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                            legend: 'fechas',
                                            legendPosition: 'middle',
                                            legendOffset: 32
                                        }}
                                        axisLeft={{
                                            tickSize: 5,
                                            tickPadding: 5,
                                            tickRotation: 0,
                                            legend: 'número de contratos',
                                            legendPosition: 'middle',
                                            legendOffset: -40
                                        }}
                                        labelSkipWidth={12}
                                        labelSkipHeight={12}
                                        labelTextColor={{
                                            from: 'color',
                                            modifiers: [
                                                [
                                                    'darker',
                                                    1.6
                                                ]
                                            ]
                                        }}
                                        valueFormat={value =>
                                            `${Number(value).toLocaleString('es-ES', {
                                                minimumFractionDigits: 0,
                                            })}`
                                        }
                                        legends={[
                                            {
                                                dataFrom: 'keys',
                                                anchor: 'bottom-right',
                                                direction: 'column',
                                                justify: false,
                                                translateX: 120,
                                                translateY: 0,
                                                itemsSpacing: 2,
                                                itemWidth: 100,
                                                itemHeight: 20,
                                                itemDirection: 'left-to-right',
                                                itemOpacity: 0.85,
                                                symbolSize: 20,
                                                effects: [
                                                    {
                                                        on: 'hover',
                                                        style: {
                                                            itemOpacity: 1
                                                        }
                                                    }
                                                ]
                                            }

                                        ]}
                                        role="application"
                                    />
                                </Card>
                            </Col>


                        </Row>


                        <Row className="margin-reset w-100">

                        </Row>
                    </Container>
                </div>
            </>
        );
    }
}

export default withApollo(Header);
